import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'src/hooks/useAuth';
import { SkillResolutionService } from '../SkillResolutionService';

// Queue tab — server-side filtered/sorted/paginated. `placeholderData` keeps
// the previous page's rows on screen while the next page/filter loads,
// instead of flashing to the empty state.
export const useSkillResolutionQueue = ({
  status,
  side,
  minOccurrences,
  sort,
  suggested,
  search,
  page,
  pageSize,
  enabled = true,
}) => {
  const { getUserInfo } = useAuth();
  const isCse = getUserInfo()?.roles?.includes('ahedge_cse');

  return useQuery({
    queryKey: [
      'skill-resolution',
      'queue',
      status,
      side,
      minOccurrences,
      sort,
      suggested,
      search,
      page,
      pageSize,
    ],
    queryFn: () =>
      SkillResolutionService.getQueue({
        status,
        side,
        minOccurrences,
        sort,
        suggested,
        search,
        page,
        pageSize,
      }),
    enabled: isCse && enabled,
    placeholderData: (prev) => prev,
  });
};

// Record detail — fetched on demand for whichever norm is open in the
// review modal. Cached per norm, so paging back to one already seen this
// session doesn't refetch within the default staleTime.
export const useSkillResolutionQueueDetail = (
  nameNorm,
  { enabled = true } = {}
) => {
  const { getUserInfo } = useAuth();
  const isCse = getUserInfo()?.roles?.includes('ahedge_cse');

  return useQuery({
    queryKey: ['skill-resolution', 'queue-detail', nameNorm],
    queryFn: () => SkillResolutionService.getQueueDetail(nameNorm),
    enabled: isCse && enabled && !!nameNorm,
  });
};
